import { render, staticRenderFns } from "./CoandaEffectViz.vue?vue&type=template&id=6dd3b27e&scoped=true"
import script from "./CoandaEffectViz.vue?vue&type=script&lang=js"
export * from "./CoandaEffectViz.vue?vue&type=script&lang=js"
import style0 from "./CoandaEffectViz.vue?vue&type=style&index=0&id=6dd3b27e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3b27e",
  null
  
)

export default component.exports